import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Spin } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import {
  CreateFileApi,
  GetServiceTypeListApi,
} from "../../../api/request/service";
import CopyFileModal from "./CopyFileModal";
import { useDispatch } from "react-redux";
import { setIsBookKeeping } from "../../../store/Slices/userSlice";

const CreateFileModal = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [service, setService] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [isCopyDetails, setIsCopyDetails] = useState(false);
  const [showCreateBtn, setShowCreateBtn] = useState(false);

  const getServiceList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetServiceTypeListApi();
      if (data?.status) {
        setService(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getServiceList();
  }, []);

  const checkFileCount = (item) => {
    if (item?.client_file_count && item?.is_auto_fill) {
      setSelectedService(item);
      setIsCopyDetails(true);
      // setIsOpen(false);
    } else {
      createFileHandler(item);
      setShowCreateBtn(true);
    }
  };

  const createFileHandler = async (service) => {
    try {
      setIsCreateLoading(true);
      const params = {
        service_type_id: service?.id || selectedService?.id,
      };
      const { data } = await CreateFileApi(params);
      if (data?.status) {
        toast.success(data?.message);
        // setIsOpen(false);
        navigate(`/file/${data?.data?.id}`);
        dispatch(
          data?.data?.is_bookkeeping
            ? setIsBookKeeping(true)
            : setIsBookKeeping(false)
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsCreateLoading(false);
    }
  };

  useEffect(() => {
    if (!isCopyDetails) setSelectedService("");
  }, [isCopyDetails]);

  return (
    <>
      <div>
        {showCreateBtn && (
          <div className="text-center mt-8">
            <LoadableButton
              isLoading={isCreateLoading}
              onClick={createFileHandler}
              lable="Create File"
              loadingLable="Creating file..."
              disabled={!selectedService}
            />
          </div>
        )}
      </div>

      <CopyFileModal
        isOpen={isCopyDetails}
        setIsOpen={setIsCopyDetails}
        data={selectedService}
        createFileHandler={createFileHandler}
        isCreateLoading={isCreateLoading}
      />
    </>
  );
};

export default CreateFileModal;
